import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { reveal, EASE } from "@/lib/motion";
import MaskLines from "@/components/MaskLines";

const QUESTIONS = [
  {
    q: "Moet alles weg?",
    a: "Nee. We kunnen de hele ruimte leeghalen of alleen de afgesproken spullen. Jij beslist wat blijft.",
  },
  {
    q: "Voeren jullie spullen af?",
    a: "Dat spreken we vooraf af. Bruikbare spullen kunnen na jouw toestemming naar hergebruik; overige spullen naar een passende afvalverwerker.",
  },
  {
    q: "Wat kost een klus?",
    a: "Dat hangt af van de hoeveelheid, trappen, bereikbaarheid en afvoer. Je ontvangt een prijsopgave voordat je akkoord geeft.",
  },
  {
    q: "Hoe vraag ik een offerte aan?",
    a: "Bel ons, stuur een e-mail of gebruik WhatsApp. Met je plaats, een omschrijving en enkele overzichtsfoto's kunnen we de klus met je bespreken. Het formulier hieronder zet je aanvraag klaar als bericht.",
  },
  {
    q: "Doen jullie ook schoonmaak of sloop?",
    a: "De basis is uitruimen en bezemschoon opleveren. Grote sloopwerken, specialistische reiniging en gevaarlijke stoffen vallen buiten onze opruimservice.",
  },
];

export default function Questions() {
  const [open, setOpen] = useState(-1);

  return (
    <section className="section questions" data-testid="questions">
      <MaskLines lines={["Goed om te weten."]} testId="questions-titel" />
      {QUESTIONS.map((item, i) => {
        const isOpen = open === i;
        return (
          <motion.div className="faq-item" {...reveal(i * 0.05, 10)} data-testid={`faq-item-${i + 1}`}>
            <button
              type="button"
              className="faq-summary"
              aria-expanded={isOpen}
              aria-controls={`faq-answer-${i + 1}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              data-testid={`faq-summary-${i + 1}`}
            >
              {item.q}
              <span aria-hidden="true">+</span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen ? (
                <motion.div
                  id={`faq-answer-${i + 1}`}
                  className="faq-answer"
                  data-testid={`faq-answer-${i + 1}`}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: EASE }}
                >
                  <p>{item.a}</p>
                </motion.div>
              ) : null}
            </AnimatePresence>
          </motion.div>
        );
      })}
    </section>
  );
}
